import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { IInputNumberProps } from 'components/uiKit/InputNumber'
import InputNumber from 'components/uiKit/InputNumber'

const FieldNumber = ({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<IInputNumberProps, number | null>) => {
  const handleChange = useCallback(
    (value?: number | null) => onChange({ name, value }),
    [name, onChange],
  )

  return <InputNumber {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldNumber) as typeof FieldNumber
